import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import '../../Cantar/style.css';
import './style.css';
import { random } from 'utils';
import Floater from './floater';

function getRandomStyles(color) {
  var mt = random(0);
  var ml = random(30);
  var dur = random(5) + 20;
  return {
    backgroundColor: `${color}b3`,
    color,
    boxShadow: `inset -7px -3px 10px rgba(255,255,255,0.3)`,
    margin: `${mt}px 0 0 ${ml}px`,
    animation: `floating ${dur}s ease infinite`,
    willChange: `transform`,
  };
}

const customIcons = {
  play: <img src={'/play.png'} alt="play" height={30} />,
  pause: <img src={'/pause.png'} alt="play" height={30} />,
  volume: <img src={'/sound.png'} alt="volume" height={20} />,
  volumeMute: <img src={'/mute.png'} alt="mute" height={20} />,
};

const customProgressBar = [RHAP_UI.MAIN_CONTROLS];

export const ScoreCard = ({ active, sm = 4, data, score, steps }) => {
  return (
    <Grid
      item
      sm={sm}
      container
      direction="row"
      justifyContent="space-between"
      alignItems={'center'}
      className="score-card"
      style={{ marginTop: data.length < 6 ? '20px' : 'inherit' }}
    >
      <Grid item sm={8} style={{ marginLeft: 10 }}>
        <Typography color="primary" variant={'h4'}>
          {active.spanishName}
        </Typography>
      </Grid>
      <Grid item sm={3}>
        <AudioPlayer
          autoPlay
          src={active.audio}
          layout={'stacked'}
          showJumpControls={false}
          showSkipControls={false}
          customControlsSection={[]}
          customProgressBarSection={customProgressBar}
          customIcons={customIcons}
        />
      </Grid>
      <Grid item sm={5} style={{ marginLeft: 10 }}>
        <Typography color="primary" variant={'h4'} style={{ marginRight: 'auto' }}>
          Score {score}
        </Typography>
      </Grid>
      <Grid item sm={3}>
        <Typography color="primary" variant={'h4'} style={{ marginLeft: 'auto' }} align="center">
          {data.length - steps}/{data.length}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const Baloon = ({ item, handleBaloonPop }) => {
  // memoise the getRandomStyles
  const memoisedGetRandomStyles = React.useMemo(() => getRandomStyles(item.color), [item.color]);

  return (
    <Grid item sm={4} onClick={() => handleBaloonPop(item)}>
      <Floater>
        <div id={`balloon-container`}>
          <div className="balloon" style={memoisedGetRandomStyles}>
            <img
              src={item.transparent}
              alt={item.name}
              style={{
                height: '70%',
                width: '75%',
                objectFit: 'contain',
                verticalAlign: 'middle',
              }}
            />
          </div>
        </div>
      </Floater>
    </Grid>
  );
};

export const EmptyBaloon = () => {
  return (
    <Grid item sm={4}>
      <Floater>
        <div id={`balloon-container`}>
          <div className="empty-balloon"></div>
        </div>
      </Floater>
    </Grid>
  );
};

export const ActiveOption = ({ selected, active, old }) => {
  return (
    <Grid
      item
      sm={6}
      container
      direction={'column'}
      alignItems={'center'}
      justifyContent={selected?.spanishName === active?.spanishName ? 'space-between' : 'center'}
      component={Paper}
      style={{
        marginTop: 25,
        padding: 10,
        backgroundColor: '#FDF6AC',
      }}
    >
      {selected ? (
        selected?.spanishName === active?.spanishName ? (
          <>
            <h2
              style={{
                fontWeight: 'normal',
                backgroundImage: `linear-gradient(to left, #ec268f, #1c358f, #16B697, #16B697, #4BB1FC)`,
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent',
                textAlign: 'center',
                margin: '0px 0px',
              }}
              key={'gradually'}
            >
              ¡Muy Bien!
            </h2>
            <img
              src={!old ? selected.transparent : selected.image}
              alt={'correctImage'}
              style={{ width: 150, height: 150 }}
            />
            <Typography variant="h4" color={'primary'} align="center" style={{ padding: 5, color: selected.color }}>
              {selected.spanishName}
            </Typography>
          </>
        ) : (
          <img
            style={{
              width: 200,
              height: 'auto',
              objectFit: 'cover',
              verticalAlign: 'middle',
            }}
            src="/tryagain.gif"
            alt="tryagain"
          />
        )
      ) : (
        <h2
          style={{
            fontWeight: 'normal',
            backgroundImage: `linear-gradient(to left, #ec268f, #1c358f, #16B697, #16B697, #4BB1FC)`,
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            textAlign: 'center',
            margin: '0px 0px',
            fontSize: 35,
          }}
          key={'gradually'}
        >
          {active.spanishName}
        </h2>
      )}
    </Grid>
  );
};

export const TimeCard = ({ minutes, seconds }) => {
  return (
    <Grid item sm={6} container direction="row" justifyContent="center" alignItems={'center'}>
      <Typography color="primary" variant={'h4'}>
        {minutes}:{seconds}
      </Typography>
    </Grid>
  );
};
